<template>
  <div :class="$style.container">
    <!-- KDA -->
    <div :class="[$style.stat, $style.kda]">
      <div :class="$style.label">KDA</div>
      <div :class="$style.value">
        <div :class="$style.val">{{ stats.kills }}</div>
        <div :class="$style.slash">/</div>
        <div :class="$style.val">{{ stats.deaths }}</div>
        <div :class="$style.slash">/</div>
        <div :class="$style.val">{{ stats.assists }}</div>
      </div>
    </div>
    <!-- LHD -->
    <div :class="[$style.stat, $style.lhd]">
      <div :class="$style.label">Lh / Dn</div>
      <div :class="$style.value">
        <div :class="$style.val">{{ stats.last_hits }}</div>
        <div :class="$style.slash">/</div>
        <div :class="$style.val">{{ stats.denies }}</div>
      </div>
    </div>
    <!-- OTHER STATS -->
    <div
      :class="[$style.stat, $style[stat.value]]"
      v-for="(stat, index) in otherStats"
      :key="`stat-${index}`"
    >
      <div :class="$style.label">{{ stat.label }}</div>
      <div :class="$style.value">
        <div :class="$style.val">{{ stats[stat.value] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Player Stats',
  props: {
    stats: {
      type: Object,
      required: true
    }
  },
  computed: {
    otherStats() {
      return [
        {
          label: 'Net Worth',
          value: 'net_worth'
        },
        {
          label: 'Kill Participation',
          value: 'kill_participation'
        },
        {
          label: 'GPM',
          value: 'gpm'
        },
        {
          label: 'XPM',
          value: 'xpm'
        },
        {
          label: 'Hero Damage',
          value: 'hero_damage'
        },
        {
          label: 'Building Damage',
          value: 'building_damage'
        },
        {
          label: 'Hero Healing',
          value: 'hero_healing'
        },
        {
          label: 'Camps Stacked',
          value: 'camps_stacked'
        }
      ]
    }
  }
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 4vw 8vw;
  padding: 2vw 4vw;
  border-radius: 0.6rem;
  border: 0.1rem solid rgba(var(--color_black-rgb), 0.5);
  background: rgba(#162024, 0.95);
  box-shadow: 0 0.05rem 0.2rem rgba(var(--color_black-rgb), 0.5);

  .stat {
    display: flex;
    flex-direction: column;

    .label {
      color: var(--color_primary);
      font-weight: bold;
      font-size: 0.6rem;
    }

    .value {
      display: flex;
      align-items: center;
      gap: 1vw;
      color: white;

      .val {
        font-weight: bold;
      }

      .slash {
        font-size: 0.8rem;
        opacity: 0.8;
      }
    }
  }
}
</style>
